// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 671 ? "connect_wallet" : chunkId) + "." + {"11":"97a4998a","146":"55e5c863","277":"ff9c78d7","385":"3c62e0e4","422":"689c939b","671":"85cf62a1","872":"1ea16e67"}[chunkId] + ".js";
};